import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { OpeningHourRes } from 'features/openingHours/types/openingHours.types'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'

export const useFetchOpeningHour = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)

	const { data: openingHour, isSuccess: isOpeningHourSuccess } = useQuery<OpeningHourRes>({
		queryKey: queryKeys.openingHours.detail(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.openingHour(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		openingHour,
		isOpeningHourSuccess
	}
}
